<template>
  <div class="color-line">
    <div v-for="(item, index) in colors"
      :key="index"
      :style="{background: item, height: height}"
      class="item"
      v-show="!max || index < max"
    />
  </div>
</template>

<script>
export default {
  name: 'color-line-vertical',
  props: {
    colors: Array,
    max: Number,
  },
  computed: {
    height() {
      const max = this.max || this.colors.length;
      return `${(1 / max) * 100}%`;
    },
  },
};
</script>

<style scoped>
  .color-line {
    border-radius: 5px;
    overflow: hidden;
  }
</style>
